// @flow

import React from "react";
import { GSGrid } from "@components";
import { type StepProps } from "@components";

type OwnProps = $Exact<{
  rawData?: ?(Object[]),
  columnsData: Object[],
}>;

type Props = $Exact<{
  ...StepProps,
  ...OwnProps,
}>;

export default function StepTable(props: Props) {
  function data() {
    return props.rawData || [];
  }

  return props.editable && <GSGrid columns={props.columnsData} rows={data()} />;
}
